import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-shadow: ", ", 0px 12px 12px 10px;\n  color: white;\n  display: block;\n  font-size: 12px !important;\n  font-weight: 500;\n  left: ", "%;\n  padding: 3px 8px;\n  border-radius: ", ";\n  position: absolute;\n  top: ", "px;\n  transform: translate(-50%);\n  z-index: 2;\n  &::after {\n    content: '';\n    background: url(\"", "\");\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 8px;\n    height: 4px;\n  }\n  transition: all 400ms;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  color: ", ";\n  margin-top: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  top: 10px;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  margin: 11px 0 0;\n  font-size: 12px;\n  line-height: 16px;\n  color: ", ";\n  text-align: center;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  right: 50.7%;\n}\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  width: ", "px;\n  height: ", "px;\n  top: ", "px;\n  right: ", "px;\n  border-radius: 50%;\n  position: absolute;\n}\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      ", " 300ms ease-out;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 10px;\n  position: relative;\n  height: ", "px;\n  min-width: ", "px;\n  width: ", "%;\n  animation: ", "\n  animation-fill-mode: both;\n  z-index: 2;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    from {\n      width: 0%;\n    }\n    to {\n      width: ", "%;\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  z-index: 3;\n  height: ", "px;\n  border-radius: 100px;\n  background: ", ";\n  margin-bottom: 30px;\n  position: relative;\n  margin-top: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { compose, defaultProps, withProps } from 'recompose';
import { theme } from '../../theme';
import roundedTooltip from '../../assets/icons/tooltip-rounded-triangle.svg';
import styled, { keyframes, css } from '../../utils/styling/styled-components';
import { PROGRESS_BAR, PROGRESS_BAR_HELP_TEXT, PROGRESS_BAR_MAX, PROGRESS_BAR_MIN, PROGRESS_BAR_TOOLTIP } from '../../utils/testing/TestIDs';
var enhance = compose(defaultProps({
  max: 100,
  value: 0
}), withProps(function (_ref) {
  var value = _ref.value,
      minLabel = _ref.minLabel,
      maxLabel = _ref.maxLabel,
      max = _ref.max,
      percentage = _ref.percentage;
  return {
    maxLabel: maxLabel,
    minLabel: minLabel,
    percentage: percentage !== null && percentage !== void 0 ? percentage : value / max * 100,
    value: Math.round(value)
  };
}));
var DISTANCE_FROM_BAR = -35;
var TOTAL_TOOLTIP_HEIGHT = DISTANCE_FROM_BAR + 36;
var BAR_HEIGHT = 10;
var TEXT_HEIGHT = 27;
var Container = styled.div(_templateObject(), function (props) {
  return props.text ? "".concat(TOTAL_TOOLTIP_HEIGHT + BAR_HEIGHT + TEXT_HEIGHT) : "".concat(TOTAL_TOOLTIP_HEIGHT + BAR_HEIGHT);
});
var ProgressWrapper = styled.div(_templateObject2(), function (props) {
  return props.height || 10;
}, function (props) {
  return props.wrapperColor;
}, function (props) {
  return props.withTooltip ? "".concat(TOTAL_TOOLTIP_HEIGHT, "px") : '0';
});

var animateWidth = function animateWidth(width) {
  return keyframes(_templateObject3(), width);
};

var ProgressBar = styled.div(_templateObject4(), function (props) {
  return props.backgroundColor || props.theme.colors.green;
}, function (props) {
  return props.height || 10;
}, function (props) {
  return props.height || 10;
}, function (props) {
  return props.percentFulfilled;
}, function (props) {
  return props.animated && css(_templateObject5(), animateWidth(props.percentFulfilled));
});
var ProgressIcon = styled.div(_templateObject6(), function (props) {
  return props.color || props.theme.colors.white;
}, function (props) {
  return props.height * 0.4 || 4;
}, function (props) {
  return props.height * 0.4 || 4;
}, function (props) {
  return Math.floor(props.height * 0.3) || 3;
}, function (props) {
  return props.height * 0.3 || 3;
});
var MidBarProgressIcon = styled(ProgressIcon)(_templateObject7());
var ProgressText = styled.p(_templateObject8(), function (props) {
  return props.theme.colors.stone;
});
var ValueContainer = styled.div(_templateObject9(), function (props) {
  return props.withTooltip && 'position: absolute;';
});
var Value = styled.p(_templateObject10(), function (props) {
  return props.theme.colors.stone;
}, function (props) {
  return props.labelPosition;
});
var Tooltip = styled.div(_templateObject11(), function (props) {
  return props.theme.colors.green;
}, function (props) {
  return props.theme.shadows.smDark;
}, function (props) {
  return props.percentage;
}, function (props) {
  return props.theme.borderRadius.small;
}, DISTANCE_FROM_BAR, roundedTooltip);

var getProgressBar = function getProgressBar(_ref2) {
  var className = _ref2.className,
      text = _ref2.text,
      withTooltip = _ref2.withTooltip,
      maxLabel = _ref2.maxLabel,
      minLabel = _ref2.minLabel,
      height = _ref2.height,
      _ref2$showCirclesOnWr = _ref2.showCirclesOnWrapper,
      showCirclesOnWrapper = _ref2$showCirclesOnWr === void 0 ? true : _ref2$showCirclesOnWr,
      backgroundColor = _ref2.backgroundColor,
      _ref2$primaryCircleCo = _ref2.primaryCircleColor,
      primaryCircleColor = _ref2$primaryCircleCo === void 0 ? theme.colors.white : _ref2$primaryCircleCo,
      _ref2$wrapperCirclesC = _ref2.wrapperCirclesColor,
      wrapperCirclesColor = _ref2$wrapperCirclesC === void 0 ? theme.colors.stoneLight : _ref2$wrapperCirclesC,
      _ref2$wrapperColor = _ref2.wrapperColor,
      wrapperColor = _ref2$wrapperColor === void 0 ? theme.colors.ivory : _ref2$wrapperColor,
      labelPosition = _ref2.labelPosition,
      percentage = _ref2.percentage,
      _ref2$animated = _ref2.animated,
      animated = _ref2$animated === void 0 ? false : _ref2$animated;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressWrapper, {
    className: className,
    "data-testid": PROGRESS_BAR,
    height: height,
    wrapperColor: wrapperColor
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    height: height,
    percentFulfilled: percentage,
    withTooltip: withTooltip,
    backgroundColor: backgroundColor,
    animated: animated
  }, /*#__PURE__*/React.createElement(ProgressIcon, {
    height: height,
    color: primaryCircleColor
  })), showCirclesOnWrapper && /*#__PURE__*/React.createElement(ProgressIcon, {
    height: height,
    color: wrapperCirclesColor
  }), showCirclesOnWrapper && /*#__PURE__*/React.createElement(MidBarProgressIcon, {
    height: height,
    color: wrapperCirclesColor
  }), minLabel && maxLabel && /*#__PURE__*/React.createElement(ValueContainer, {
    withTooltip: withTooltip
  }, /*#__PURE__*/React.createElement(Value, {
    labelPosition: labelPosition,
    "data-testid": PROGRESS_BAR_MIN
  }, minLabel), /*#__PURE__*/React.createElement(Value, {
    labelPosition: labelPosition,
    "data-testid": PROGRESS_BAR_MAX
  }, maxLabel))), text && /*#__PURE__*/React.createElement(ProgressText, {
    "data-testid": PROGRESS_BAR_HELP_TEXT
  }, text));
};

var ContinuousProgressBarV2 = enhance(function (props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.withTooltip ? /*#__PURE__*/React.createElement(Container, {
    text: props.text
  }, /*#__PURE__*/React.createElement(Tooltip, {
    "data-testid": PROGRESS_BAR_TOOLTIP,
    percentage: props.percentage
  }, props.label), getProgressBar(props)) : /*#__PURE__*/React.createElement(React.Fragment, null, getProgressBar(props)));
});
export { ContinuousProgressBarV2 };